import Checkbox from "@/components/ui/Checkbox";

const CHECKLIST_ITEMS = [
  { label: "Business documents are valid and readable", helper: "No blurry, cropped or tampered images" },
  { label: "PAN matches the business name", helper: "Verify the legal name on the PAN card" },
  { label: "Aadhaar details match the owner name", helper: "Name matches the Aadhaar photograph" },
  { label: "Selfie matches the Aadhaar photograph", helper: "Compare the face against the Aadhaar photo" },
  { label: "Bank account name matches the PAN name", helper: "Cross-check the account holder name" },
  { label: "Address details are complete and consistent", helper: "Pincode, city and state match the address" },
];

interface VerificationChecklistProps {
  checked: boolean[];
  onToggle: (index: number) => void;
}

export default function VerificationChecklist({ checked, onToggle }: VerificationChecklistProps) {
  const verified = checked.filter(Boolean).length;

  return (
    <div className="rounded-[10px] border border-line bg-white p-5 shadow-card">
      <h3 className="text-lg font-semibold text-ink">Verification Checklist</h3>
      <p className="mt-0.5 text-[13px] text-ink-secondary">Confirm each item before approving</p>

      <div className="mt-3 flex flex-col gap-3.5">
        {CHECKLIST_ITEMS.map((item, i) => (
          <div key={item.label}>
            <Checkbox
              checked={!!checked[i]}
              onChange={() => onToggle(i)}
              label={item.label}
            />
            <p className="mt-0.5 pl-7 text-xs text-ink-secondary">{item.helper}</p>
          </div>
        ))}
      </div>

      <p className="mt-4 border-t border-[#F1F5F9] pt-3 text-[13px] text-ink-secondary">
        {verified} of {CHECKLIST_ITEMS.length} verified
      </p>
    </div>
  );
}